import { Seo, breadcrumbSchema } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { Breadcrumb } from "@/components/Breadcrumb";
import { useLang } from "@/i18n/LangContext";

const Section = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-display text-xl md:text-2xl font-bold tracking-tight">{title}</h2>
    <div className="mt-4 space-y-3 text-sm md:text-base leading-relaxed text-plum/85">{children}</div>
  </section>
);

// Rendu des paragraphes : \n -> <br/>, emails transformés en liens mailto.
export const RichParagraph = ({ text }) => (
  <p>
    {text.split("\n").map((line, i) => (
      <span key={i}>
        {i > 0 && <br />}
        {line.split(/([\w.+-]+@[\w-]+\.[\w.]+)/g).map((part, j) =>
          /^[\w.+-]+@[\w-]+\.[\w.]+$/.test(part) ? (
            <a key={j} href={`mailto:${part}`} className="font-semibold text-terracotta-deep underline decoration-terracotta/40 underline-offset-4">
              {part}
            </a>
          ) : (
            part
          ),
        )}
      </span>
    ))}
  </p>
);

export default function Legal() {
  const { t } = useLang();
  const p = t.legalPage;

  return (
    <>
      <Seo
        title={p.seo.title}
        description={p.seo.description}
        path="/mentions-legales"
        schemas={[
          breadcrumbSchema([
            { name: t.common.home, path: "/" },
            { name: p.breadcrumb, path: "/mentions-legales" },
          ]),
        ]}
      />
      <div className="px-5 md:px-10 pt-36 md:pt-44 pb-24 md:pb-32" data-testid="legal-page">
        <div className="mx-auto max-w-3xl">
          <Breadcrumb items={[{ label: t.common.home, to: "/" }, { label: p.breadcrumb }]} />
          <Reveal>
            <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tighter">
              {p.h1}
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            {p.sections.map((s) => (
              <Section key={s.title} title={s.title}>
                {s.paragraphs.map((para, i) => (
                  <RichParagraph key={i} text={para} />
                ))}
              </Section>
            ))}
          </Reveal>
        </div>
      </div>
    </>
  );
}
